module.exports = __webpack_public_path__ + "img/IP_laterne_sketch01_preview.ac6f29ed.png";